import { render } from "./v-text-field.vue?vue&type=template&id=5bf5ef10"
import script from "./v-text-field.vue?vue&type=script&lang=js"
export * from "./v-text-field.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__